import classNames from 'classnames'
import './index.scss'
import Badge from '../../../core/badge'
import Dropdown from '../../../core/dropdown'
import {ClockIcon, EditIcon, HorizontalMoreIcon, ListIcon, TrashIcon} from '../../../../icons'
import {MenuDivider, MenuItem} from '@szhsin/react-menu'
import {colors} from '../../../../utils/colors'
import Tooltip from '../../../core/tooltip'
import TextHelper from '../../../../utils/text'
import {useNamespaceTranslations} from '../../../../utils/hooks/useNamespacesTranslations'
import {envConfig} from '../../../../utils/env'
import {DateFormats, formatDate} from '../../../../utils/date'

const {isReadOnlyModeEnabled} = envConfig

const ActionButton = ({isDarkMode, onPopup, onDelete, text}) => (
    <Dropdown menuButton={
        <button className={classNames({'table-action-btn': true, dark: isDarkMode})}>
            <HorizontalMoreIcon />
        </button>
    }>
        <MenuItem onClick={onPopup} disabled={isReadOnlyModeEnabled}>
            <span className="d-flex"><EditIcon /></span>
            <span>{text.edit}</span>
        </MenuItem>
        <MenuDivider />
        <MenuItem className="danger" onClick={onDelete} disabled={isReadOnlyModeEnabled}>
            <span className="d-flex"><TrashIcon stroke={colors.colorRed} /></span>
            <span>{text.delete}</span>
        </MenuItem>
    </Dropdown>
)

const ConditionChip = ({condition, text}) => (
    <div className="condition-chip">
        <div className="chip-row-top">
            <span className="chip-metric" title={condition?.key?.value?.label}>
                {condition?.key?.value?.label}
            </span>
        </div>
        <div className="chip-row-bottom">
            <span className="chip-operator">{condition?.operator?.value?.label}</span>
            <span className="chip-value">{condition?.values?.value}</span>
            {condition?.last_time?.value != null && (
                <span className="chip-time">
                    <ClockIcon width={10} height={10} stroke="currentColor" />
                    {condition.last_time.value}{text.min_short || 'm'}
                </span>
            )}
        </div>
    </div>
)

const ListItem = ({item, isDarkMode, showEditModal, onDeleteClick, isHighlighted}) => {
    const text = useNamespaceTranslations('rulesets')
    const updatedAt = formatDate(item?.updated_at || new Date(), DateFormats.DASH_YMD_TIME_SHORT)

    return (
        <div className={classNames('ruleset-item', {dark: isDarkMode, highlighted: isHighlighted})}>
            <div className="ruleset-item-header">
                <div className="header">
                    <span className="header-title" title={item?.title?.value}>
                        {TextHelper.textLengthChecker(item?.title?.value, 25)}
                    </span>
                    {item?.type && (
                        <Badge
                            color={item.type.color}
                            className="metric-type-badge"
                            title={item.type.label || item.type.category_label}
                        >
                            {item.type.label || item.type.category_label || item.type.value}
                        </Badge>
                    )}
                    {item?.component?.label && (
                        <Badge color="secondary" className="metric-component-badge" title={item.component.label}>
                            {TextHelper.textLengthChecker(item.component.label, 18)}
                        </Badge>
                    )}
                    {item?.type && (
                        <span className="d-flex gap-half align-items-center">
                            <Tooltip
                                trigger="mouseenter"
                                content={
                                    <div className="condition-chips">
                                        {item?.value_type?.value?.label && (
                                            <span className="chip-pill">{item.value_type.value.label}</span>
                                        )}
                                        {item?.conditions?.pairs?.map((condition, index) => (
                                            <ConditionChip
                                                key={index}
                                                condition={condition}
                                                text={text}
                                            />
                                        ))}
                                    </div>
                                }
                            >
                                <span className="target"><ListIcon /></span>
                            </Tooltip>
                        </span>
                    )}
                </div>
            </div>
            <div className="ruleset-item-details">
                <div className="ruleset-info">
                    <Badge color={item?.urgency?.value.value} className="text-capitalize">
                        {item?.urgency?.value.label}
                    </Badge>
                </div>
                <div className="ruleset-info">
                    <Badge color={item?.enable.value ? 'success' : 'warning'}>
                        {item?.enable?.value ? text.enabled : text.disabled}
                    </Badge>
                </div>
                <div className="ruleset-info">
                    <p>{updatedAt}</p>
                </div>
                <div className="ruleset-info actions">
                    <ActionButton
                        onPopup={() => showEditModal(item)}
                        onDelete={() => onDeleteClick(item)}
                        isDarkMode={isDarkMode}
                        text={text}
                    />
                </div>
            </div>
        </div>
    )
}

export default ListItem